import React from "react";

export const ButtonLoader = ({ className }) => {
  return (
    <button
      type="button"
      className={`btn btn-primary ${className ? className : undefined}`}
    >
      <img
        src="/assets/images/ball-triangle.svg"
        alt="loader"
        className="loader-dynamic-color h-5"
      />
    </button>
  );
};
